import { render, staticRenderFns } from "./StickyMessages.vue?vue&type=template&id=577da75b"
import script from "./StickyMessages.vue?vue&type=script&lang=js"
export * from "./StickyMessages.vue?vue&type=script&lang=js"
import style0 from "./StickyMessages.vue?vue&type=style&index=0&id=577da75b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports